var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("suc-period-component", {
        staticClass: "mb-2",
        attrs: { defaultType: _vm.defaultType },
        on: _vm._d({}, [_vm.periodChangedEvent, _vm.init]),
      }),
      _vm.isDay
        ? _c("plan-day-table-component", { attrs: { filter: _vm.dayFilter } })
        : _c("plan-week-or-month-table-component", {
            attrs: { filter: _vm.weekOrMonthFilter },
          }),
      _c("add-work-shift-modal"),
      _c("add-absence-modal"),
      _c("add-overtime-modal"),
      _c("edit-overtime-modal"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }